export const getEmbed = <T>(resource: any, rel: string, def: any = {}): T[] => {
  const embed = resource && resource._embedded && resource._embedded[rel];
  return embed || def;
};
